import React from 'react'
import {CloseModal} from 'assets/icons'
import IconTooltip from 'components/iconTooltip/IconTooltip'
import 'styles/main.scss'

// `closeLabel` is opt-in so the many other modals sharing this header stay as they are.
const Modalheader = ({children,hide,hideShow,closeLabel}) => {
    const closeButton = (
        <button
            className="p-1 ml-auto bg-transparent border-0 text-black ft-2xl leading-none font-semibold outline-none focus:outline-none my-auto"
            onClick={hide}
            aria-label={closeLabel}
        >
            <span className="bg-transparent text-black h-6 w-6 text-2xl">
                <CloseModal></CloseModal>
            </span>
        </button>
    )

    return (
        <div className="flex items-start justify-between gap-3 p-5 rounded-t">
            <h3 className="ft-lg tab:ft-2xl text-[#202124] font-semibold my-auto">
                {children}
            </h3>
            {hideShow ? (
                closeLabel ? (
                    // Below the cross: the modal clips what overflows its top edge.
                    <div className="ml-auto my-auto">
                        <IconTooltip label={closeLabel} placement="bottom">
                            {closeButton}
                        </IconTooltip>
                    </div>
                ) : closeButton
            ) : ''}
        </div>
    )
}

export default Modalheader
